import {CommonModule, NgOptimizedImage} from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule } from 'src/app/shared/material.module';

import { GlobalSearchComponent } from './header/global-search/global-search.component';
import { HeaderComponent } from './header/header.component';
import { LayoutComponent } from './layout.component';
import { MenuComponent } from './menu/menu.component';
import { MenuService } from './menu/menu.service';
import { PageTitleComponent } from './page-title/page-title.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SignUpSuccessComponent } from './sign-up/sign-up-success/sign-up-success.component';
import { WalletModalComponent } from './header/wallet-modal/wallet-modal.component';
import { AccountMembersModalComponent } from './header/account-members-modal/account-members-modal.component';

@NgModule({
  declarations: [
    HeaderComponent,
    GlobalSearchComponent,
    LayoutComponent,
    MenuComponent,
    PageTitleComponent,
    SignUpComponent,
    SignUpSuccessComponent,
    WalletModalComponent,
    AccountMembersModalComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    NgbTooltipModule,
    RouterModule,
    SharedModule,
    MaterialModule,
    ReactiveFormsModule,
    NgOptimizedImage
  ],
  exports: [
    LayoutComponent,
    PageTitleComponent
  ],
  providers: [MenuService]
})
export class LayoutModule { }
